import axios from 'axios'
import { requestError } from '@/services/http'
import { config } from '@/config/index'
import store from '@/store'

const httpAuth = axios.create({
  baseURL: `${config.API_URL}`
})

httpAuth.defaults.headers.common['Access-Control-Allow-Headers'] = 'Origin, Accept, Content-Type, Authorization, Access-Control-Allow-Origin'

function trataToken (acesso) {
  let auth = localStorage.getItem('auth')
  auth = auth ? JSON.parse(auth) : {}

  let token = store ? store.getters['auth/token'](acesso) : auth.token
  httpAuth.defaults.headers.common['Authorization'] = `Bearer ${token}`
}

export default {
  async get (url, acesso = {}) {
    trataToken(acesso)
    return requestError(httpAuth.get(url))
  },
  async post (url, data, acesso = {}) {
    trataToken(acesso)
    return requestError(httpAuth.post(url, data))
  },
  async put (url, data, acesso = {}) {
    trataToken(acesso)
    return requestError(httpAuth.put(url, data))
  },
  async delete (url, acesso = {}) {
    trataToken(acesso)
    return requestError(httpAuth.delete(url))
  }
}
